<div role="presentation" class="eva-3-message -eva-3-mb-xlg -eva-3-mt-lg" [ngClass]="messageStyle">
    <div class="message-icon-container">
        <i [ngClass]="messageIcon" class="message-icon"></i>
    </div>
    <div class="message-header">
        <h5 class="eva-3-h5 message-title" *ngIf="message?.title">{{ message.title }}</h5>
    </div>
    <div class="message-body">
        <div class="eva-3-body-2 message-text" *ngIf="message?.text">{{ message.text }}</div>
    </div>
</div>
